import { render, staticRenderFns } from "./rePwd.vue?vue&type=template&id=b9b981d2&scoped=true&"
import script from "./rePwd.vue?vue&type=script&lang=js&"
export * from "./rePwd.vue?vue&type=script&lang=js&"
import style0 from "./rePwd.vue?vue&type=style&index=0&id=b9b981d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b981d2",
  null
  
)

export default component.exports